var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.message),expression:"message"}],staticClass:"message",class:_vm.classes,attrs:{"id":_vm.id},domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }